import React from "react";
import {
  Accordion as MatAccordion,
  makeStyles,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import { Typography } from "@packages/ui";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  accordion: {
    root: {
      border: "1px solid rgba(0, 0, 0, .125)",
      boxShadow: "none",
      "&:not(:last-child)": {
        borderBottom: 0,
      },
      "&:before": {
        display: "none",
      },
      "&.Mui-expanded": {
        backgroundColor: "lightGrey",
      },
      "&.MuiAccordionSummary-content.Mui-expanded": {
        margin: "12px 0",
      },
    },
  },
  summary: {
    minHeight: 0,
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&.MuiAccordionSummary-content.Mui-expanded": {
      margin: "12px 0",
    },
    "&.MuiAccordionSummary-root.Mui-expanded": {
      minHeight: 56,
    },
    "&$expanded": {
      margin: "12px 0",
    },
  },
}));

const Accordion = (props) => {
  const classes = useStyles();
  let style = `${classes.accordion}`;
  style = `${style} ${props.style}`;

  return (
    <MatAccordion className={style}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${props.key}a-content`}
        id={`panel${props.key}a-header`}
      >
        <Typography variant={"h3"}>Accordion 1</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
          sit amet blandit leo lobortis eget.
        </Typography>
      </AccordionDetails>
    </MatAccordion>
  );
};

export default Accordion;
